export default __webpack_public_path__ + "static/oh-logo-d70e9a52e59e2372b84e0ef638837a96.png";